import $ from "jquery";

import slider from "./modules/slider";
import datepicker from "./modules/datepicker";
import custom from "./modules/custom";
import menu from "./modules/menu";

// Initialisation globale
$(document).ready(async () => {
  slider.init();
  await datepicker.init();
  custom.init();
  menu.init();
});
